var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1399 1.8599V9.30657L13.4732 10.6399V1.8599C13.4732 1.12657 12.8732 0.526569 12.1399 0.526569H3.3599L4.69324 1.8599H12.1399Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34657 0.399902L0.399902 1.3399L1.47324 2.41324V11.1932C1.47324 11.9266 2.07324 12.5266 2.80657 12.5266H11.5866L12.6599 13.5999L13.5999 12.6599L1.34657 0.399902ZM2.80657 11.1932V3.74657L7.5199 8.4599L6.97324 9.19324L5.47324 7.19324L3.47324 9.8599H8.9199L10.2532 11.1932H2.80657Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIcon);
export default __webpack_public_path__ + "static/media/type-icon.953f054dbaa47e53d5642bcfc26134bd.svg";
export { ForwardRef as ReactComponent };